module.exports = __webpack_public_path__ + "img/brasao-home-office.c243fa79.png";